<template>
  <div class="">
    
    <div class="imageCustomFullPage">
      <router-link to="/designportal">
        <img src="img/assets/logos/PortalBG_SM_Blank.png">
      </router-link>
    </div>
    <!--<div class="row">
      <div class="col-1"></div>
      <div class="col-10">
        <div class="row">
          <div class="landingPageButton">
            <router-link to="/designportal">
              <img src="img/assets/logos/DesPort.svg">
            </router-link>
          </div>
          <div class="landingPageButton">
            <router-link to="/designreview">
              <img src="img/assets/logos/DesRev.svg">
            </router-link>
          </div>
          <div class="landingPageButton">
            <router-link to="/lessonslearned">
              <img src="img/assets/logos/LessLear.svg">
            </router-link>

          </div>
          <div class="landingPageButton">
            <router-link to="/projectdashboard">
              <img src="img/assets/logos/ProDash.svg">
            </router-link>

          </div>
          <div class="landingPageButton">
            <router-link to="/culturediversity">
              <img src="img/assets/logos/C&D.svg">
            </router-link>
          </div>
        </div>
        <br>
        <br>
        <div class="row">
          <div class="landingPageButton">
            <router-link to="/digital">
              <img src="img/assets/logos/Dig.svg">
            </router-link>
          </div>
          <div class="landingPageButton">
            <router-link to="/360projectreview">
              <img src="img/assets/logos/360.svg">
            </router-link>

          </div>
          <div class="landingPageButton">
            <router-link to="/kpitracker">
              <img src="img/assets/logos/KPI.svg">
            </router-link>

          </div>
          <div class="landingPageButton">
            <router-link to="/managementresources">
              <img src="img/assets/logos/ManRes.svg">
            </router-link>

          </div>
          <div class="landingPageButton">
            <router-link to="/communityportal">
              <img src="img/assets/logos/ComPort.svg">
            </router-link>
          </div>
        </div>
      </div>
      <div class="col-1"></div>
      <div class="hubLogo">
        <img height="400" src="img/brand/SRLA_Banner.png">
      </div>
      <div class="col-4">

      </div>
      <div class="col-2">

      </div>
      <div class="col-5 pr-0 align-self-center">

        <div class="row justify-content-center m-0 mt-6">
          <div class="col-md-8 offset-md-2 pr-0">
            <router-link to="/commercial">
                <div  height="70" class="btn_commercial"></div>
            </router-link>
            <router-link to="/management">
              <div  height="70" class="btn_mngmt"></div>
            </router-link>
            <router-link to="/collaboration">
              <div  height="70" class="btn_collab"></div>
            </router-link>
            <router-link to="/design">
              <div  height="70" class="btn_design"></div>
            </router-link>
            <router-link to="/reporting">
              <div  height="70" class="btn_report"></div>
            </router-link>
            <router-link to="/virtualreality">
              <div  height="70" class="btn_vr"></div>
            </router-link>
          </div>
        </div>
      </div> 

    </div>-->



  </div>
</template>

<script>
// import VueFrame from 'vue-frame'
export default {
  name: 'LandingPageNew',
  components: {
    // VueFrame
  },
  data() {
    return {
      links: {
        collab: ""
      },
      accessToken: ""
    }
  },
}
</script>

<style scoped>
  .landingPageButton {
    width: 16%;
    margin-left: 2%;
    margin-right: 2%;
  }
  .imageCustomFullPage {
      /* position: absolute;

      width: 100%;

      height: 100%; */

    }
</style>
